import React from 'react';

import {
    WizardSectionPanel
} from './WizardSectionPanel.jsx';

import {
    listeningDefinitions
} from '../enums/listeningDefinitions.jsx';

import AuthorsFilters from './AuthorsFilters.jsx';
import DomainsFilters from './DomainsFilters.jsx';
import ThemeInclusions from './ThemeInclusions.jsx';

const {
    noiseSuppressionTitle,
    noiseSuppressionDescription
} = listeningDefinitions['saved-search'];

export default function NoiseSuppression() {

    return (
        <WizardSectionPanel
            title={noiseSuppressionTitle}
            description={noiseSuppressionDescription}
            collapsable={true}
        >
            <div className='tlw-my-10 tlw-flex tlw-flex-col tlw-text-gray-900'>

                <ThemeInclusions
                />

                <hr
                    className='tlw-mx-8 tlw-my-10 tlw-border-gray-600'
                />

                <AuthorsFilters
                />

                <hr
                    className='tlw-mx-8 tlw-my-10 tlw-border-gray-600'
                />

                <DomainsFilters
                />


            </div>
        </WizardSectionPanel>
    );
}
